import base from "../../baseurl";
import token from "../../getTk";

const showAll = async (eventId) => {
  const tokenA = token.get();
  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const value = Array.from(Array(1000).keys());
  const Create = await api
    .post("disciplines/showall", {
      json: {
        disciplineTypes: value,
        eventId,
      },
      timeout: false,
    })
    .json();
  console.log(Create);
  return Create;
};

export default showAll;
